// Store.js
const DB = require('./IndexedDb')
const appUtils = require('../common/appUtils')

module.exports = {
  messages: [],
  store: {},
  db: new DB(),
  initDb: function (done) {
    return this.db.openDB(function (err, db) {
      if (err) {
        return done(err)
      }
      console.log('db objectStore : ', db.objectStoreNames.length)
      return done(null, db);
    })
  },
  getMessage: function (messageId) {
    var self = this
    if (typeof messageId == 'number') {
      return this.messages.find(function (message) {
        if (message.properties && typeof message.properties.id == 'number') {
          return message.properties.id === messageId          
        }        
      })
    }
  },
  setMessage: function (Message) {
    this.messages.push(Message)
    return Message
  },
  saveMessage: function (messageId, done) {
    var self = this
    var message = this.getMessage(messageId)
    return this.initDb(function (err, success) {
      if (err) {
        return done(err)
      }
      return self.db.addEntry(message.properties, function (err, success) {
        if (err) {
          console.log(err)
        }
        console.log('message added')
        return done(null, true)
      })
    })
  },
  retrieveMessage: function (messageId, done) {
    var self = this
    // var pickedTemplate = self.get('pickedTemplate')
    if (typeof messageId === 'number') {
      return this.initDb(function (err, success) {
        if (err) {
          return done(err)
        }
        return self.db.getEntry(messageId, function (err, result) {
          if (err) {
            return done(err)
          }
          return done(null, result)
        })
      })
    }
  },
  getUser: function () {
    // console.log('//////////////////////////')
    // console.log('getUser')
    return this.user
  },
  setUser: function (User) {
    this.user = User
    return this.user
  },
  setUserProperties: function (userProps, done) {
    var self = this, medias = [];
    return this.initDb(function (err, success) {
      if (err) {
        return done(err)
      }
      !!userProps
        && userProps.appData
        && userProps.appData.medias
        && userProps.appData.medias.length
        && (medias = appUtils.hostify(userProps.appData.medias, self.NODE_ENV))
        && !!medias
        && (userProps.appData.medias = medias);
      // 
      return self.db.addUser(userProps, function (err, success) {
        if (err) {
          return done(err)
        }
        // 
        return done(null, true)
      });
    });
  },
  retrieveUserProperties: function (done) {
    var self = this
    return this.initDb(function (err, success) {
      if (err) {
        return done(err)
      }
      return self.db.getUser(function (err, result) {
        if (err) {
          return done(err)
        }
        return done(null, result)
      })
    })
  },
  dropProperties: function (done) {
    var self = this
    return this.db.clearObjectStore('User', function (err, success) {
      if (err) {
        return done(err)
      }
      delete self.user;
      // 
      return self.db.clearObjectStore('Messages', function (err, success) {
        if (err) {
          return done(err)
        }
        delete self.messages;
        //
        window.localStorage.setItem('store', '{}');
        // 
        return done(null, success)
      })
    }) 
  },
  getMediaDashboard: function () {
    return this.MediaDashboard
  },
  setMediaDashboard: function (MediaDashboard) {
    this.MediaDashboard = MediaDashboard
    return this.MediaDashboard
  },
  set: function (key, value) {
    var store = window.JSON.parse(window.localStorage.getItem('store'))
    if (store) {
      this.store = store
    }
    // console.log('// set - - - - - - - - - - - - - - - ')
    // console.log(key, value)
    // console.log('// - - - - - - - - - - - - - - - ')
    this.store[key] = value
    window.localStorage.setItem('store', window.JSON.stringify(this.store))
  },
  get: function (key) {
    var store = window.JSON.parse(window.localStorage.getItem('store'))
    // console.log('// get - - - - - - - - - - - - - - - ')
    // console.log(key, store[key])
    // console.log('// - - - - - - - - - - - - - - - ')
    return store[key]
  }
}




//////////////////
// WEBPACK FOOTER
// ./~/annonces-app-modules/models/Store.js
// module id = 84
// module chunks = 0